import React from 'react';
import PropTypes from 'prop-types';
import Colours from './Colours';

const ColoursWithState = (props) => {
    return <Colours Wrapper={SingleColourWithState} {...props} />;
};
ColoursWithState.propTypes = {};
export default ColoursWithState;

/* an individual colour swatch */
const SingleColourWithState = (props) => {
    const { selectProduct, partNumber, children } = props;

    return <div onClick={() => selectProduct({ partNumber })}>{children}</div>;
};

SingleColourWithState.propTypes = {
    selectProduct: PropTypes.func.isRequired,
    partNumber: PropTypes.string,
    children: PropTypes.any.isRequired,
};
